import * as syncProtocol from 'y-protocols/sync';
import * as encoding from 'lib0/encoding';
import * as decoding from 'lib0/decoding';

export const EVT_DOC_SYNC = 'doc:sync';

export function encodeUpdateMessage(update) {
    const enc = encoding.createEncoder();
    encoding.writeVarUint(enc, syncProtocol.messageYjsUpdate);
    encoding.writeVarUint8Array(enc, update);
    return encoding.toUint8Array(enc);
}

export function setupSocketSync(doc, opts = {}) {
    let socket;
    // Lazy-require collaborationSocket to allow injection in tests
    if (opts.socket) {
        socket = opts.socket;
    } else {
        // eslint-disable-next-line global-require
        socket = require('../socket/client').collaborationSocket;
    }

    let destroyed = false;

    const handleDocUpdate = (update, origin) => {
        if (origin === socket) return;
        socket.emit(EVT_DOC_SYNC, encodeUpdateMessage(update));
    };
    doc.on('update', handleDocUpdate);

    const handleInboundFrame = (frame) => {
        if (destroyed) return;
        try {
            const dec = decoding.createDecoder(
                frame instanceof Uint8Array ? frame : new Uint8Array(frame),
            );
            const replyEnc = encoding.createEncoder();
            syncProtocol.readSyncMessage(dec, replyEnc, doc, socket);
            if (encoding.length(replyEnc) > 0) {
                socket.emit(EVT_DOC_SYNC, encoding.toUint8Array(replyEnc));
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('[socket-sync] inbound frame failed', err);
        }
    };
    socket.on(EVT_DOC_SYNC, handleInboundFrame);

    function sendSyncStep1() {
        if (destroyed) return;
        if (!socket.connected) return;
        const enc = encoding.createEncoder();
        syncProtocol.writeSyncStep1(enc, doc);
        socket.emit(EVT_DOC_SYNC, encoding.toUint8Array(enc));
    }

    function destroy() {
        if (destroyed) return;
        destroyed = true;
        socket.off(EVT_DOC_SYNC, handleInboundFrame);
        doc.off('update', handleDocUpdate);
    }

    return { sendSyncStep1, destroy };
}
